import { render, staticRenderFns } from "./SidebarCartCrossSell.vue?vue&type=template&id=23468c81&"
import script from "./SidebarCartCrossSell.vue?vue&type=script&lang=js&"
export * from "./SidebarCartCrossSell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23468c81')) {
      api.createRecord('23468c81', component.options)
    } else {
      api.reload('23468c81', component.options)
    }
    module.hot.accept("./SidebarCartCrossSell.vue?vue&type=template&id=23468c81&", function () {
      api.rerender('23468c81', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/SidebarCartCrossSell.vue"
export default component.exports